import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Injectable({providedIn: 'root'})
@Pipe({
  name: 'separateThreeComma'
})
export class SeparateThreeCommaPipe implements PipeTransform {
  numberWithCommas(x) {
    return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') ?? '';
  }

  transform(value: any): string {
    if (value != null) {
      return this.numberWithCommas(value);
    }
    return '0';
  }

}
